// Copyright (c) Microsoft. All rights reserved.

export interface BucketsState {
    Buckets: BucketItem[];
    AuthDocsScope: string;
}

export const initialState: BucketsState = {
    Buckets: [],
    AuthDocsScope: '',
};

export enum BucketType {
    BucketSource = 'BucketSource',
    Bucket = 'Bucket',
}

export interface BucketItem {
    id: string;
    title: string;
    url?: string;
    documentType?: string;
    parent?: BucketItem;
    color?: string;
    type: BucketType;
    selected: boolean;
}
